export const GET_PICKUP_TIMES_BY_CITY_ID = 'GET_PICKUP_TIMES_BY_CITY_ID'
export const GET_PICKUP_TIMES_BY_CITY_ID_SUCCESS =
  'GET_PICKUP_TIMES_BY_CITY_ID_SUCCESS'

export const SAVE_PICKUP_TIMES_LIST = 'SAVE_PICKUP_TIMES_LIST'
export const SAVE_PICKUP_TIMES_LIST_SUCCESS = 'SAVE_PICKUP_TIMES_LIST_SUCCESS'

export const ADD_PICKUP_TIME = 'ADD_PICKUP_TIME'
export const REMOVE_PICKUP_TIME = 'REMOVE_PICKUP_TIME'
export const CANCEL_PICKUP_TIME = 'CANCEL_PICKUP_TIME'

export const PICKUP_TIMES_TABLE_THEAD_VALUES = [
  'day',
  'start',
  'end',
  'actions',
]

export const TIME_FORMATS = {
  AM_PM: 'h A',
  AM_PM_WITH_MINUTES: 'h:mm A',
  HOURS_MINUTES_SECONDS: 'HH:mm:ss',
  HOURS_MINUTES: 'HH:mm',
}

export const DAYS_OF_THE_WEEK = [
  { label: 'Monday', value: '1' },
  { label: 'Tuesday', value: '2' },
  { label: 'Wednesday', value: '3' },
  { label: 'Thursday', value: '4' },
  { label: 'Friday', value: '5' },
  { label: 'Saturday', value: '6' },
  { label: 'Sunday', value: '0' },
]



// WEBPACK FOOTER //
// ./src/Reducers/PickupTimes/const.js